export default __webpack_public_path__ + "images/ki-de100d3095b62260166f474b5bd7bbb4.svg";